import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const Training = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get('/api/training');
      setRows(data || []);
    } catch (e) {
      toast.error('Failed to load training');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Training</h1>
      </div>

      {loading ? (
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600"></div>
      ) : (
        <div className="card">
          <div className="overflow-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left">
                  <th className="pr-4 py-2">Name</th>
                  <th className="pr-4 py-2">Mode</th>
                  <th className="pr-4 py-2">Attendees</th>
                  <th className="pr-4 py-2">Govt. Officials</th>
                  <th className="pr-4 py-2">Female Participants</th>
                  <th className="pr-4 py-2">Date</th>
                  <th className="pr-4 py-2">District</th>
                  <th className="pr-4 py-2">State</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.training_detail_id} className="border-t">
                    <td className="pr-4 py-2">{r.training_type}</td>
                    <td className="pr-4 py-2">{r.training_mode || '-'}</td>
                    <td className="pr-4 py-2">{r.total_attendees || 0}</td>
                    <td className="pr-4 py-2">{r.government_sector_attendees ?? r.Government_Sector_Attendees ?? 0}</td>
                    <td className="pr-4 py-2">{r.total_women || 0}</td>
                    <td className="pr-4 py-2">{r.training_start_date || ''}{r.training_end_date ? ` - ${r.training_end_date}` : ''}</td>
                    <td className="pr-4 py-2">{r.district_name || '-'}</td>
                    <td className="pr-4 py-2">{r.state_ut || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Training;


